import Handler from "../Handler";

class ConnectFailHandler extends Handler {
  execute(message) {
    let receivedData = null;
    if (message) {
      receivedData = JSON.parse(message);
    }
    this.service.connectionFailResponder(receivedData);
  }
}

export default ConnectFailHandler;
